import { TextField } from "@mui/material";
import { useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { Dialog } from "@/components/Dialog/Dialog";

interface OTPPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (otp: string) => void;
  error?: string;
}

export const OTPPopup = ({
  isOpen,
  onClose,
  onSubmit,
  error,
}: OTPPopupProps) => {
  const intl = useIntl();
  const [otp, setOtp] = useState("");

  const handleSubmit = () => {
    onSubmit(otp);
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage({
        defaultMessage: "OTP verification",
        description: "payment.otp.title",
      })}
    >
      <div className="flex flex-col gap-4 pt-4">
        <TextField
          variant="outlined"
          fullWidth
          label={intl.formatMessage({
            defaultMessage: "OTP",
            description: "payment.otp.inputLabel",
          })}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: { inputMode: "numeric", pattern: "d*" },
          }}
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder={intl.formatMessage({
            defaultMessage: "Enter OTP code",
            description: "payment.otp.inputPlaceholder",
          })}
          error={!!error}
          helperText={error}
        />

        <Button
          fullWidth
          variant="contained"
          onClick={handleSubmit}
          disabled={!otp}
        >
          {intl.formatMessage({
            defaultMessage: "Verify",
            description: "payment.otp.submitLabel",
          })}
        </Button>
      </div>
    </Dialog>
  );
};
